import * as $ from 'jquery';

$(document).ready(function(){
  
     $('body').click(function(e) {
         if ($(e.target).parents('.hamburger').length == 1 || $(e.target).parents('nav').length == 1) {
             return;
         }
 
         if ($('#nav-icon3').hasClass('open'))  {
            $('#nav-icon3').removeClass('open');
            $('nav').animate({opacity: 'hide', height: 'hide'}, 'normal');
         }
     });
 
     $('.hamburger').click(function(){
 
        if ($('#nav-icon3').hasClass('open'))  {
            $('#nav-icon3').removeClass('open');
            $('nav').stop().animate({opacity: 'hide', height: 'hide'}, 'normal');
        }
        else {
            $('#nav-icon3').addClass('open');
            $('nav').stop().animate({opacity: 'show', height: 'show'}, 'normal');
        }
     });

});